import { useMemo } from "react";
import SkeletonModalRequoteParts from "../skeletonModalCancelParts";
import { CancelableQuoteItemResponse } from "@/main/models/response";
import ResultNotFoundComponent from "@/main/components/shared/resultNotFound/resultNotFoundComponent";
import { getTranslateByKey, isEmpty, isNullUndefined } from "@/main/services/utils";
import * as S from "./styles";
import QuoteProcurementPartInfo from "@/main/components/shared/quoteProcurementPartInfo/quoteProcurementPartInfo";
import KogCheckbox from "@/main/components/shared/checkbox/kogCheckbox";
import { IMAGE_DEFAULT } from "@/main/services/constants";
import { FormControlLabel } from "@mui/material";

interface IAreaPartsSelectProps {
	type: "abovePrive" | "unanswered";
	dataParts?: CancelableQuoteItemResponse[];
	isLoadingParts: boolean;
	numbersParts?: number;
	optionsSelected: string[];
	handleToggleCheckbox: (guid: string | string[]) => void;
}
function AreaPartsSelectCancel({
	optionsSelected,
	type,
	dataParts,
	isLoadingParts,
	numbersParts,
	handleToggleCheckbox = () => {},
}: IAreaPartsSelectProps) {
	const allCheckboxesSelected = useMemo(() => {
		if (isNullUndefined(dataParts)) return false;

		return dataParts.every((item) => optionsSelected.includes(item.guidQuoteItem));
	}, [JSON.stringify(optionsSelected)]);

	function handleToggleCheckboxAll() {
		if (isNullUndefined(dataParts)) return;

		const allCheckboxesSelected = dataParts.every((item) => optionsSelected.includes(item.guidQuoteItem));

		if (allCheckboxesSelected) {
			const allIds = dataParts.map((item) => item.guidQuoteItem);

			handleToggleCheckbox(allIds);
		} else {
			const allIdsUnselected = dataParts.reduce((acc, item) => {
				if (!optionsSelected.includes(item.guidQuoteItem)) {
					acc.push(item.guidQuoteItem);
				}
				return acc;
			}, [] as string[]);
			handleToggleCheckbox(allIdsUnselected);
		}
	}

	if (isLoadingParts)
		return (
			<>
				{Array.from(new Array(numbersParts)).map((_, index) => (
					<SkeletonModalRequoteParts key={index} />
				))}
			</>
		);
	if (isNullUndefined(dataParts)) return <ResultNotFoundComponent />;
	if (isEmpty(dataParts)) return <></>;

	const keyTranslatePartSelect =
		type === "abovePrive" ? "information.partsAbovePriceCap" : "information.partsWithNoAnswer";
	const titlePartsSelect = getTranslateByKey(keyTranslatePartSelect);

	return (
		<S.Container>
			<S.Headerpart>
				<S.HeaderTitle>{titlePartsSelect}</S.HeaderTitle>
				<S.AreaSelectAll>
					<FormControlLabel
						label={getTranslateByKey("information.selectAll")}
						labelPlacement="start"
						control={
							<KogCheckbox
								id={`id-createOrder-checkbox-selectAçç-${type}`}
								checked={allCheckboxesSelected}
								value={allCheckboxesSelected}
								onChange={() => handleToggleCheckboxAll()}
							/>
						}
					/>
				</S.AreaSelectAll>
			</S.Headerpart>
			{dataParts.map((item) => (
				<S.RowPart key={item.guidQuoteItem} onClick={() => handleToggleCheckbox(item.guidQuoteItem)}>
					<S.ImagePart src={IMAGE_DEFAULT} />
					<QuoteProcurementPartInfo data={item.quoteProcurementPartInfo} renderType="column" />
					<KogCheckbox
						id={`id-createOrder-checkbox-select-${type}-${item.guidQuoteItem}`}
						checked={optionsSelected.includes(item.guidQuoteItem)}
						value={optionsSelected.includes(item.guidQuoteItem)}
						onChange={() => handleToggleCheckbox(item.guidQuoteItem)}
					/>
				</S.RowPart>
			))}
		</S.Container>
	);
}

export default AreaPartsSelectCancel;
